const getToken = () => {
  return JSON.parse(localStorage.getItem("token"))?.token ||
         JSON.parse(localStorage.getItem("User"))?.Token || null;
}

export default getToken;